import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function updateDocumentConversationPrivacy(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENT_CONVERSATION_UPDATE_PRIVACY,
    (organisationId, projectId, documentId, conversationId, isPrivate) =>
      requestor
        .patch(
          `${basePath}/organisation/${organisationId}` +
            `/project/${projectId}` +
            `/document/${documentId}` +
            `/conversation/${conversationId}}/privacy`,
          {isPrivate},
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
